import { Box, IconButton, Slider, Typography, useTheme } from '@mui/material'

import { concatToSXProp } from 'utils/style'

import DeleteIcon from '../icons/DeleteIcon'
import DownloadIcon from '../icons/DownloadIcon'
import PauseIcon from '../icons/PauseIcon'
import PlayIcon from '../icons/PlayIcon'
import audioRecordStyles from '../styles'
import { formattingTime } from '../utils'

interface AudioPlayerProps {
  audioSrc: string | undefined
  isPlaying: boolean
  duration: number
  trackProgress: number
  handleProgressChange: (e: Event, value: number) => void
  playRecording: () => void
  pauseRecording: () => void
  deleteRecording: () => void
}

export default function AudioPlayer({
  audioSrc,
  isPlaying,
  duration,
  trackProgress,
  handleProgressChange,
  playRecording,
  pauseRecording,
  deleteRecording,
}: AudioPlayerProps): JSX.Element {
  const { audioWrap, iconBox, recordTime, flexBox, sliderStyle, mr12 } = audioRecordStyles

  const theme = useTheme()
  const primaryColor = theme.palette.primary.main

  return (
    <Box sx={concatToSXProp(audioWrap, flexBox)}>
      {isPlaying ? (
        <IconButton onClick={pauseRecording} sx={concatToSXProp(iconBox, mr12)}>
          <PauseIcon color={primaryColor} />
        </IconButton>
      ) : (
        <IconButton onClick={playRecording} sx={concatToSXProp(iconBox, mr12)}>
          <PlayIcon color={primaryColor} />
        </IconButton>
      )}
      <IconButton download href={audioSrc!} sx={concatToSXProp(iconBox, mr12)}>
        <DownloadIcon color={primaryColor} />
      </IconButton>
      <Typography>{formattingTime(trackProgress)}</Typography>
      <Slider
        onChange={handleProgressChange}
        size="small"
        value={(trackProgress * 100) / duration ?? 0}
        sx={sliderStyle}
      />
      <Typography sx={recordTime}>{formattingTime(duration)}</Typography>
      <IconButton onClick={deleteRecording} sx={iconBox}>
        <DeleteIcon color={primaryColor} />
      </IconButton>
    </Box>
  )
}
